<template>
	<div>
		<!-- <el-card>
			<el-form :model="form" ref="form" :inline="true">
				<el-form-item label="订单编号:">
					<el-input placeholder="请输入订单编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
                
				<el-form-item label="状态:">
					<el-select v-model="form.state" placeholder="请选择状态">
						<el-option label="充值统计" value="0"></el-option>
						<el-option label="支出统计" value="1"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="流水日期:">
                    <el-date-picker
                        v-model="form.time"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
				
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
					<el-button @click="resetForm()">重置</el-button>
				</el-form-item>
			</el-form>
			
		</el-card> -->

		<!-- <WriterMoney  :items="writerMoney" /> -->

        <el-card>
            <div class="top">
                <div @click="getguidata(1,'今日流水')">
				    <span>今日流水</span>
                </div>
                
                <div @click="getguidata(2,'本月流水')">
                    <span>本月流水</span>
                </div>
                <div @click="getguidata(3,'总流水')">
                    <span>总流水</span>
                </div>
                <div @click="getguidata(3,'流水分析')">
                    <span>流水分析</span>
                </div>
            </div>
            
        </el-card>
		
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="id" label="编号" >
				</el-table-column>
				<el-table-column prop="creat_time" label="时间" >
				</el-table-column>
				<el-table-column  label="买家账户" >
					<template slot-scope="scope">
						<div class="userInfo" @click="openUserInfo(scope.row.uid)">{{ scope.row.pay_name }}</div>
					</template>
				</el-table-column>
                <el-table-column prop="goods" label="购买商品" >
				</el-table-column>
                <el-table-column prop="payMoney" label="金额" >
				</el-table-column>
                <el-table-column prop="good_type" label="商品类目" >
				</el-table-column>
                <el-table-column prop="payee" label="卖家" >
				</el-table-column>
                <el-table-column prop="orderState" label="订单情况" >
				</el-table-column>
                <el-table-column prop="payChannel" label="付款方式" >
				</el-table-column>
                <!-- <el-table-column prop="price" label="备注" >
				</el-table-column> -->
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
		<el-dialog
            :visible.sync="centerDialogVisible"
            width="50%"
            center>
            <div slot="title" class="dialog-title">
				<el-row>
					<span class="dialog-title-text" >{{dialogtext}}</span>
				</el-row>
			</div>
            <DayWarter :options="chartOptions" ></DayWarter>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
		<el-dialog title="用户信息" :visible.sync="dialogFormVisible">
			<div>
				用户姓名：<el-input v-model="userinfo.name" disabled style="width: 150px;"></el-input>
				用户账户：<el-input v-model="userinfo.id" disabled style="width: 100px;"></el-input>
				可用余额：<el-input v-model="userinfo.money" disabled style="width: 100px;"></el-input>
			</div>
			<div style="margin: 10px 0;">
				用户手机：<el-input v-model="userinfo.tel" disabled style="width: 150px;"></el-input>
				身份证号：<el-input v-model="userinfo.idcard" disabled style="width: 200px;"></el-input>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Pageing from '../../components/page/page.vue'
	import WriterMoney from '../../components/board/commentWriter'
	import DayWarter from '../../components/echarts/dayWarter.vue'
	import {
		getDealerList,
		getDealerGuiData
	} from '../../api/board.js'
	import {
		getadjustuserinfo,
	} from '../../api/recharge.js'
	export default {
		components: {
			Pageing,
			WriterMoney,
			DayWarter
		},
		data() {
			return {
				dialogtext:"今日流水",
                centerDialogVisible: false,
				dialogFormVisible: false,
				userinfo: {
					name: '',
					id: '',
					tel: '',
					idcard: '',
					money: '0'
				},
				chartOptions: {
					title: {
					left: 'center'
				},
				tooltip: {
					trigger: 'item'
				},
				legend: {
					orient: 'vertical',
					left: 'left'
				},
				series: [
					{
						name: '交易金额',
						type: 'pie',
						radius: '50%',
						data: [
							{ value: 40, name: '实体商品' },
							{ value: 20, name: '虚拟商品' },
							{ value: 10, name: 'ip授权' },
							{ value: 30, name: '约稿' },
						],
						emphasis: {
							itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
					]
				},
                pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
				formLabelWidth: '120px',
				
				page:1,
				size:10,
				total:0,
				tableData: [],
				runmoney:0,
				checkAll: false,
				form: {
					orderid: '',
					time: '',
                    name:'',
					state:''
				},
				
				forminfo:{},
				writerMoney:[],
			};
		},
		mounted() {
			this.getuserlist()
		},
		computed: {
			isincome(e){
				console.log(e);
				return true;
			}
		},
		methods: {
            
			resetForm(){
				this.form.orderid =''
				this.form.time =''
                this.form.name =''
				this.form.state =''
				this.getuserlist()
			},
			getuserlist(){
				getDealerList({
					page:this.page,
					where:this.form,
                    //type:"all"
				}).then(res=>{
					this.tableData = res.data
					this.total = res.total 
					this.writerMoney = res.writerMoney 
				})
			},
			openUserInfo(uid){
				this.getuserinfo(uid)
				this.dialogFormVisible = true
			},
			getuserinfo(uid) {
				getadjustuserinfo({
					uid: uid,
					type:1
				}).then(res => {
					this.userinfo.name = res.name
					this.userinfo.id = res.user
					this.userinfo.tel = res.tel
					this.userinfo.idcard = res.idcard
					this.userinfo.money = res.money
				})
			},
			getguidata(time,text){
				this.dialogtext = text
				this.centerDialogVisible = true
				getDealerGuiData({
					time:time
				}).then(res=>{
					this.chartOptions.series[0].data[0].value = res.data.entity
					this.chartOptions.series[0].data[1].value = res.data.virtual
					this.chartOptions.series[0].data[2].value = res.data.IPAuthorize
					this.chartOptions.series[0].data[3].value = res.data.commission
				})
			},
			
			submitForm() {
				this.page = 1
				this.getuserlist()
			},
            gofinduser(val){
                this.form.name = val
                this.getuserlist()
            },
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			}
			
		}
	};
</script>

<style lang="less" scoped>
	.runmoney{
		display: flex; 
		flex-direction: column;
		align-items: center;
		ul{
			display: flex;
			li{
				text-align: center;
				margin: 0 20px;
			}
		}
	}
    .top{
        display: flex;
        div{
            width: 150px;
            font-size: 26px;
            cursor: pointer;
        }
    }
	.userInfo{
		cursor: pointer;
	}
    
	
</style>
